export const EmployeeContractActionBarEN = {
    "employeeContractActionBar": {
        "tab": {
            "detail":"Detail",
        },
        "item": {
            "delete": "Delete",
            "history": "History",
            "update": "Update",
            "approval": "Approval",
            "undoApproval": "Undo approval",
            "liquidation": "Contract liquidation",
            "edit": "Edit",
        },
        "message": {
            "deleteAsk": "Are you sure you want to delete the contract?",
            "approvalAsk": "Are you sure you want to approval the contract?",
            "undoApprovalAsk": "Are you sure you want to liquidation the contract?"
        }
    }
}
